export interface Project {
    title: string;
    category: string;
    description: string;
    url: string;
    tags: string[];
    themeColor: string;
}

export const PROJECTS: Project[] = [
    {
        title: 'Mycelium',
        category: 'Réseau',
        description: 'Exploration visuelle de réseaux décentralisés et de structures interconnectées.',
        url: 'https://mycelium.racinetechnique.eu/',
        tags: ['P2P', 'Graph', 'Network'],
        themeColor: '#10b981' // Emerald
    },
    {
        title: 'Radioactivité',
        category: 'Éducation',
        description: 'Module pédagogique interactif pour comprendre la radioactivité et la fusion.',
        url: 'https://radioactivite.racinetechnique.eu/',
        tags: ['Physique', 'Simulation', 'Science'],
        themeColor: '#eab308' // Yellow
    },
    {
        title: 'Mécanique',
        category: 'Éducation',
        description: 'Simulation de trajectoires, vecteurs et lois de Newton en temps réel.',
        url: 'https://mecamotion.racinetechnique.eu/',
        tags: ['Mécanique', 'Vecteurs', 'Animation'],
        themeColor: '#8b5cf6' // Purple
    },
    {
        title: 'Physique Ondulatoire',
        category: 'Éducation',
        description: 'Exploration des phénomènes d\'ondes et de propagation.',
        url: 'https://physiqueunivers.racinetechnique.eu/',
        tags: ['Ondes', 'Fréquences', 'Visualisation'],
        themeColor: '#06b6d4' // Cyan
    },
    {
        title: 'Calcul Intégral',
        category: 'Éducation',
        description: 'Approche visuelle et intuitive pour comprendre le calcul intégral.',
        url: 'https://integral.racinetechnique.eu/',
        tags: ['Analyse', 'Calcul', 'Graphiques'],
        themeColor: '#ef4444' // Red
    },
    {
        title: 'Éducation Canine',
        category: 'Site Vitrine',
        description: 'Site complet pour un éducateur canin avec blog et présentation des services.',
        url: 'https://edu-toutou.racinetechnique.eu/',
        tags: ['Conseil', 'Animaux', 'Design'],
        themeColor: '#f97316' // Orange
    },
    // Projects below appear on the "All Projects" page
    {
        title: 'Maths Interactif',
        category: 'Éducation',
        description: 'Cours interactifs de mathématiques avec visualisations dynamiques et exercices.',
        url: 'https://mathinteractif.racinetechnique.eu/',
        tags: ['React', 'Vite', 'Interactive', 'Maths'],
        themeColor: '#3b82f6' // Blue
    },
    {
        title: 'IAM Visualizer',
        category: 'Sécurité',
        description: 'Outil de visualisation des politiques et permissions IAM (Identity Access Management).',
        url: 'https://iam-visualizer.racinetechnique.eu/',
        tags: ['Cloud', 'Security', 'AWS'],
        themeColor: '#6366f1' // Indigo
    },
    {
        title: 'Log Sanitizer',
        category: 'DevTools',
        description: 'Utilitaire pour anonymiser et nettoyer les fichiers de logs avant partage.',
        url: 'https://logsanitizer.racinetechnique.eu/',
        tags: ['Privacy', 'Tool', 'Parsing'],
        themeColor: '#64748b' // Slate
    },
    {
        title: 'Packet Wasm',
        category: 'Réseau',
        description: 'Analyseur de paquets réseau haute performance fonctionnant entièrement dans le navigateur.',
        url: 'https://packetwasm.racinetechnique.eu/',
        tags: ['Wasm', 'Network', 'Performance'],
        themeColor: '#ec4899' // Pink
    }
];
